import { MaintenanceUpdateState } from '@hkm/shared/domain/maintenanceUpdate/models/maintenanceUpdateState';
import { Store } from '@hkm/store/interfaces/store';

export const selectMaintenanceUpdateState = (state: Store): MaintenanceUpdateState  => state.maintenanceUpdateData;



// WEBPACK FOOTER //
// ./src/components/shared/Templates/Maintenance/shared/domain/selectors.ts